// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3YRgg","calendarButtons":"ClockData_calendarButtons__euc3w"};